import { generate } from '@issuu/iutk';
export function setIutkCookie() {
    function getDomain() {
        if (typeof document !== 'undefined') {
            const m = /(?:t?)issuu.com$/.exec(document.domain);
            return !!m ? m[0] : null;
        }
        return null;
    }
    const iutk = generate();
    const domain = getDomain();
    const maxAge = 60 * 60 * 24 * 30 * 6;
    document.cookie = `iutk=${iutk}${domain ? `;domain=${domain}` : ''};path=/;max-age=${maxAge};samesite=none;secure`;
}
